<template>
  <b-container>
    <b-card
      v-if="renderPage"
      title="Link de Recorrência"
    >
      <b-card class="card-form">
        <b-row class="mb-2 column-change">
          <b-col>
            <validation-observer ref="simpleRules">
              <b-form @submit.prevent>
                <b-card title="Dados do Recebedor">
                  <b-row>
                    <b-col
                      sm="12"
                      md="12"
                      lg="6"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Nome Completo"
                        label-for="v-first-name"
                      >
                        <validation-provider
                          #default="{ errors }"
                          rules="required"
                          name="Nome Completo"
                        >
                          <b-form-input
                            id="v-first-name"
                            v-model="shipping.name"
                            placeholder="Digite o nome do cliente"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      sm="12"
                      md="12"
                      lg="6"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Documento"
                        label-for="v-document"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Documento"
                          rules="required|document"
                        >
                          <b-form-input
                            id="v-document"
                            v-model="document"
                            v-mask="[
                              '###.###.###-##',
                              '##.###.###/####-##',
                              '##.###.###',
                            ]"
                            type="text"
                            placeholder="Informe o Documento"
                            :state="errors.length > 0 ? false : null"
                            style="width: 100%"
                          />

                          <small class="text-danger">{{
                            errors[0]
                          }}</small></validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col
                      sm="12"
                      md="12"
                      lg="6"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="E-mail"
                        label-for="v-email"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="E-Mail"
                          rules="required|email"
                        >
                          <b-form-input
                            id="v-email"
                            v-model="shipping.email"
                            type="email"
                            placeholder="Email"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      sm="12"
                      md="12"
                      lg="6"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Telefone"
                        label-for="v-mobile"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Telefone"
                          rules="required|phone"
                        >
                          <b-form-input
                            id="v-mobile"
                            v-model="shipping.phone"
                            v-mask="['(##) #####-####', '(##) ####-####']"
                            placeholder="Informe o telefone"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col
                      sm="12"
                      md="12"
                      lg="6"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Data de Nascimento"
                        label-for="v-born"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Data de Nascimento"
                          rules="required"
                        >
                          <b-form-input
                            id="v-born"
                            v-model="dot"
                            placeholder="Data de Nascimento"
                            type="date"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card>
                <!-- -->
                <b-card title="Endereço do recebedor">
                  <b-row>
                    <b-col
                      sm="12"
                      lg="3"
                      md="12"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="País"
                        label-for="v-country"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="País"
                          rules="required"
                        >
                          <b-form-select
                            id="v-country"
                            v-model="shipping.country"
                            :options="options"
                            :state="errors.length > 0 ? false : null"
                            selected="32"
                            @change="checkCountry()"
                          >
                            <template v-slot:first>
                              <b-form-select-option value="BR">
                                Brasil
                              </b-form-select-option>
                            </template>
                          </b-form-select>
                          <small class="text-danger">
                            {{ errors[0] }}
                          </small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      sm="12"
                      lg="3"
                      md="12"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="CEP"
                        label-for="v-cep"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="CEP"
                          :rules="`required|${shipping.country == 'BR' ? `cep: ${shipping.state}` : ''}`"
                        >
                          <b-form-input
                            id="v-cep"
                            v-model="shipping.postal_code"
                            v-mask="req.billing.country === 'BR' ? '#####-###' : '##########'"
                            placeholder="CEP"
                            :state="errors.length > 0 ? false : null"
                            @change="shipping.country==='BR' ? searchPostalCode() : ''"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      sm="12"
                      lg="3"
                      md="12"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Estado"
                        label-for="v-state"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Estado"
                          :rules="shipping.country !== 'BR' ? 'required' : ''"
                        >
                          <b-form-input
                            id="v-state"
                            v-model="shipping.state"
                            placeholder="Estado"
                            :readonly="shipping.country === 'BR' ? true : false"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      sm="12"
                      lg="3"
                      md="12"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Cidade"
                        label-for="v-city"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Cidade"
                          :rules="shipping.country !== 'BR' ? 'required' : ''"
                        >
                          <b-form-input
                            id="v-city"
                            v-model="shipping.city"
                            placeholder="Cidade"
                            :readonly="shipping.country === 'BR' ? true : false"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col
                      sm="12"
                      md="12"
                      lg="6"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Endereço"
                        label-for="v-address"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Endereço"
                          :rules="shipping.country !== 'BR' ? 'required' : ''"
                        >
                          <b-form-input
                            id="v-address"
                            v-model="shipping.address"
                            placeholder="Endereço"
                            :readonly="shipping.country === 'BR' ? true : false"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      sm="12"
                      md="12"
                      lg="6"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Bairro"
                        label-for="v-district"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Bairro"
                          :rules="shipping.country !== 'BR' ? 'required' : ''"
                        >
                          <b-form-input
                            id="v-district"
                            v-model="shipping.district"
                            :readonly="shipping.country === 'BR' ? true : false"
                            placeholder="Bairro"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      sm="12"
                      md="6"
                      lg="3"
                      offset-xl="0"
                    >
                      <b-form-group
                        label="Número"
                        label-for="v-number"
                      >
                        <validation-provider
                          #default="{ errors }"
                          name="Número"
                          rules="required"
                        >
                          <b-form-input
                            id="v-number"
                            v-model="shipping.number"
                            type="number"
                            placeholder="Número"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col
                      sm="12"
                      md="6"
                      lg="3"
                    >
                      <b-form-group
                        label="Complemento"
                        label-for="v-complemento"
                      >
                        <b-input-group class="input-group-merge">
                          <b-form-input
                            id="v-complemento"
                            v-model="shipping.complement"
                            placeholder="Complemento"
                          />
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card>
              </b-form>
            </validation-observer>
          </b-col>
          <!-- -->
          <!-- desc card -->
          <b-col
            sm="12"
            md="6"
            lg="4"
            class="py-2"
          >
            <information
              :data="product"
            />
          </b-col>
        </b-row>
      </b-card>
      <div align="center">
        <b-button
          class="button-confirm"
          variant="primary"
          @click="validation()"
        >
          Pagar
        </b-button>
      </div>
    </b-card>
  </b-container>
</template>
<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
  BForm,
  BInputGroup,
  BButton,
  BCard,
  BContainer,
} from 'bootstrap-vue'
import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate'
import {
  required,
} from '@validations'

import Ripple from 'vue-ripple-directive'

import { payLink } from '@/service/pay/pay'
import { getPostalCode } from '@/service/others/others'

import Information from '@/layouts/components/payment-link/Information.vue'

import { callLoading } from '@/service/utilities/utilities'

const countries = require('@/information/countries').default

export default {
  components: {
    BContainer,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BInputGroup,
    BForm,
    BButton,
    BCard,
    Information,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      renderPage: false,
      document: null,
      dot: null,
      options: countries,
      checker: false,
      req: {
        user: {
          name: null,
        },
      },
      shipping: {
        name: null,
        address: null,
        number: null,
        complement: null,
        city: null,
        district: null,
        state: null,
        postal_code: null,
        country: 'BR',
        phone: null,
        email: null,
      },
    }
  },
  created() {
    this.renderPage = false
    // catch card and request information from first page
    this.req = this.$route.query.req
    this.product = this.$route.query.product
    const { hash } = this.$route.params
    // if req is empty redirect to first page
    if (this.req == null || this.req === undefined || this.req.credit_card === undefined) {
      this.$router.push(`/link-recorrencia/1/${hash}`)
    } else {
      this.renderPage = true
    }
  },
  methods: {
    // modals function
    // modal transaction error
    error(errorText) {
      this.$swal({
        title: errorText,
        icon: 'error',
        timer: 2000,
        showConfirmButton: false,
        buttonsStyling: false,
      })
    },
    // modal check
    async confirmModal() {
      await this.$bvModal
        .msgBoxConfirm('Confirmar Pagamento', {
          title: 'Por Favor Confirme',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        }).then(value => {
          this.checker = value
        })
    },
    // axios postal code api
    async searchPostalCode() {
      const response = await getPostalCode(this.shipping.postal_code)
      const {
        address, city, district, state,
      } = response.data

      this.shipping.state = state
      this.shipping.city = city
      this.shipping.address = address
      this.shipping.district = district
    },

    validation() {
      // check input validation
      this.$refs.simpleRules.validate().then(async success => {
        // if success call pay request
        if (success) { this.createLink() }
      })
    },

    // pay link
    async createLink() {
      await this.confirmModal()

      if (!this.checker) { return }

      callLoading(true, true)

      this.req.shipping = this.shipping

      this.req.shipping.postal_code = this.req.shipping.postal_code.replace('-', '')

      const { hash } = this.$route.params

      try {
        const response = await payLink('recurrence-link', hash, this.req)
        const { status } = response
        if (status === 200) {
          this.$router.push(`/recorrencia/status/${hash}`)
        }
        else if (response.data.response_message == 'AUTHORIZATION_ERROR') {
          this.error('Pagamento negado pelo emissor. Entre em contato com o emissor do cartão.')
        }
         else if (response.data.response_code == 5 || response.data.response_code == 255 || response.data.response_code == 259) { this.error('Pagamento negado pelo emissor. Entre em contato com o emissor do cartão.') } else if (response.data.response_code == 9) { this.error('Data do vencimento do cartão de crédito preenchido incorreto.') } else if (response.data.response_code == 11) { this.error('Número do cartão de crédito errado ou inexistente.') } else if (response.data.response_code == 13) { this.error('Número CVV do cartão é inválido.') } else { this.error('Falha de processamento. Entrar em contato com o suporte SoulPay.') }
      } catch {
        this.error('Falha de processamento. Entrar em contato com o suporte SoulPay.')
      } finally {
        callLoading(false)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
  @import "@core/scss/vue/pages/page-payment-link.scss";
</style>
